<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>Basic data</el-breadcrumb-item>
      <el-breadcrumb-item>Agent Info</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-page-header @back="goBack" :content="title" v-if="visible"></el-page-header>
      <el-divider v-if="visible"></el-divider>
      <!-- 头部查询部分 -->
      <el-form ref="editFormRef" :model="agentInfo" label-width="200px" :rules="editFormRules">
        <div class="left" ref="left">
          <el-form-item label="Agent name:" prop="agencyName">
            <el-input
              placeholder=" "
              :disabled="isDisabled"
              ref="activeInput"
              v-model="agentInfo.agencyName"
            ></el-input>
          </el-form-item>
          <el-form-item label="Email:" prop="email">
            <el-input
              placeholder=" "
              :disabled="isDisabled"
              ref="activeInput"
              v-model="agentInfo.email"
            ></el-input>
          </el-form-item>

          <el-form-item label="Invitation code rules:" prop="agencyPipelineName">
            <el-input disabled ref="activeInput" v-model="agentInfo.agencyPipelineName"></el-input>
          </el-form-item>
          <el-form-item label="Testing standard:" prop="testStandard">
            <el-select
              v-model="agentInfo.testStandard"
              v-if="!isZb"
              disabled
              placeholder=" "
              ref="activeInput"
            >
              <el-option
                v-for="item in testStandardList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>

            <el-select
              v-model="agentInfo.testStandard"
              v-if="isZb"
              :disabled="isDisabled"
              placeholder=" "
              ref="activeInput"
            >
              <el-option
                v-for="item in testStandardList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Area:" prop="areaList">
            <el-cascader
              filterable
              class="active"
              style="width:100%"
              ref="activeInput"
              clearable
              size="medium"
              :disabled="isDisabled"
              v-model="areaList"
              :props="{value:'id',label:'label',leaf:'hasChildren',checkStrictly: true}"
              :options="areaTreeList"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="Detail address:" prop="agencyAddress">
            <el-input
              class="active"
              placeholder=" "
              :disabled="isDisabled"
              ref="activeInput"
              v-model="agentInfo.agencyAddress"
            ></el-input>
          </el-form-item>

          <el-form-item label="Saleman:" prop="salesMan">
            <el-input
              v-if="isDisabled && isZb"
              placeholder=" "
              disabled
              ref="activeInput"
              v-model="agentInfo.salesManName"
            ></el-input>
            <el-input
              v-if="!isZb"
              placeholder=" "
              disabled
              ref="activeInput"
              v-model="agentInfo.salesManName"
            ></el-input>
            <el-select
              v-if="!isDisabled && isZb"
              class="active"
              :disabled="isDisabled"
              v-model="saleManId"
              filterable
              remote
              clearable
              placeholder=" "
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in salemanList"
                :key="item.id"
                :label="item.user_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-button v-if="isDisabled" @click="edit">Edit</el-button>
        <div v-else class="saveAndCancel">
          <el-button @click="updateAgent">Save</el-button>
          <el-button class="cancel" @click="cancel">Cancel</el-button>
        </div>
      </el-form>

      <el-row type="flex" justify="space-between">
        <div class="titleText">Employee Information</div>
        <el-button-group class="btnsList">
          <el-button
            plain
            size="small"
            icon="el-icon-setting"
            @click="clickHandlerToSetting"
          >Parameters Setting</el-button>
          <el-button
            plain
            size="small"
            icon="el-icon-s-custom"
            @click="clickHandlerToPlumber"
          >Plumber Company</el-button>
          <el-button
            plain
            size="small"
            icon="el-icon-s-custom"
            @click="cliclHandlerToManagement"
          >Plumber Management</el-button>
          <el-button
            plain
            size="small"
            icon="el-icon-plus"
            @click="openAddEmployee"
            v-hasPermission="['agent:saveEmployee']"
          >Add Employee</el-button>
          <el-button
            plain
            size="small"
            icon="el-icon-unlock"
            @click="enableBatch"
            v-hasPermission="['agent:startUser']"
          >Enable</el-button>
          <el-button
            plain
            size="small"
            icon="el-icon-lock"
            @click="disableBatch"
            v-hasPermission="['agent:stopUser']"
          >Disable</el-button>
        </el-button-group>
      </el-row>

      <!-- 表格数据部分 -->
      <el-table
        ref="multipleTable"
        :data="dataList"
        style="width: 100%"
        border
        stripe
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="loginAccount" label="Account" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="email" label="Email" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="firstName" label="First name" width="180"></el-table-column>
        <el-table-column prop="lastName" label="Last name" width="180"></el-table-column>
        <el-table-column prop="mobile" label="phone number" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="roleName" label="Role permission" width="180" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="createdTime" label="createdTime" width="180" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="status" label="status" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==='1'" type="success">Enabled</el-tag>
            <el-tag v-else-if="scope.row.status==='2'" type="info">Locked</el-tag>
            <el-tag v-else-if="scope.row.status==='3'" type="warning">Disabled</el-tag>
            <el-tag v-else type="warning"></el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="remark" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="operate" show-overflow-tooltip fixed="right" fit>
          <template slot-scope="scope">
            <div class="btnContainer">
              <el-link
                icon="el-icon-edit-outline"
                v-hasPermission="['agent:saveEmployee']"
                @click="openEditEmployee(scope.row.id)"
              >Edit</el-link>
              <el-link
                icon="el-icon-lock"
                v-hasPermission="['auth:updateOtherPwd']"
                @click="openChangePwd(scope.row.loginAccount)"
              >Change password</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>

      <!-- 员工弹窗 -->
      <edit-employee
        ref="editEmployeeDialog"
        :agentId="agentId"
        :dialogTableVisible="dialogTableVisible"
        @closeDialog="closeDialog"
        :title="dialogTitle"
      ></edit-employee>

      <!-- 修改密码 -->
      <change-pwd
        ref="editPwdDialog"
        :dialogPwdVisible="dialogPwdVisible"
        @closeDialog="closePwdDialog"
      ></change-pwd>
    </el-card>
  </div>
</template>

<script>
import Collapse from '@/components/collapse/Collapse.vue'
import CollapseItem from '@/components/collapse/CollapseItem.vue'
import EditEmployee from '@/views/basic/agentinfo/EditEmployee.vue'
import ChangePwd from '@/views/basic/agentinfo/ChangePwd.vue'

import db from '@/services/localstorage'

export default {
  components: {
    Collapse,
    CollapseItem,
    EditEmployee,
    ChangePwd,
  },
  data() {
    return {
      // 获取列表的参数对象
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      // 列表
      dataList: [],
      total: 0,
      multipleSelection: [],
      // 默认禁止input输入
      isDisabled: true,

      //
      dialogTableVisible: false,

      title: 'Agent info',
      visible:
        this.$route.query.visible == undefined
          ? false
          : this.$route.query.visible,

      //是否总部
      isZb: false,

      agentId: this.$route.query.agentId,
      testStandardList: [],
      areaTreeList: [],
      agentInfo: {},
      areaList: [],

      dialogTitle: '',

      dialogPwdVisible: false,

      // 添加表单的验证规则对象
      editFormRules: {
        agencyName: [
          {
            required: true,
            message: 'Agent name is required',
            trigger: 'blur',
          },
          {
            max: 300,
            message: 'Agent name can not more than 300 character',
            trigger: 'blur',
          },
        ],
        agencyPipelineName: [
          {
            required: true,
            message: 'Pipeine code is required',
            trigger: 'blur',
          },
          {
            min: 2,
            max: 2,
            message: 'Only enter tow letters character',
            trigger: 'blur',
          },
        ],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
        ],
        areaList: [
          { required: true, message: 'Area is required', trigger: 'blur' },
        ],
        testStandard: [
          {
            required: true,
            message: 'Testing standard is required',
            trigger: 'blur',
          },
        ],
        agencyAddress: [
          {
            required: true,
            message: 'Agency address is required',
            trigger: 'blur',
          },
        ],
        saleMan: [
          { required: true, message: 'saleMan is required', trigger: 'blur' },
        ],
      },

      salemanList: [],
      loading: false,

      saleManId: null,
    }
  },

  methods: {
    //搜索saleman
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true

        this.$post('user/searchUser', { userType: '1', keyword: query }).then(
          ({ data: res }) => {
            this.salemanList = res.data
            this.loading = false
          }
        )
      } else {
        this.options = []
      }
    },

    getEntity() {
      var agentId = this.$route.query.agentId
      if (agentId == undefined || agentId == null) {
        //查询我的代理商信息，agentId不为空说明是代理商自己权限查询自己的信息
        this.$get(`agent/getMyAgent`).then(({ data: res }) => {
          this.agentInfo = res.data
          this.agentId = this.agentInfo.id
          this.areaList = this.agentInfo.areaList

          this.salemanList = [
            {
              id: this.agentInfo.saleMan,
              user_name: this.agentInfo.salesManName,
            },
          ]
          this.getDataList()
        })
      } else {
        //说明是从总部的代理商管理跳转过来查看
        this.$get(`agent/get/${this.$route.query.agentId}`).then(
          ({ data: res }) => {
            this.agentInfo = res.data
            this.areaList = this.agentInfo.areaList
            this.salemanList = [
              {
                id: this.agentInfo.saleMan,
                user_name: this.agentInfo.salesManName,
              },
            ]
            this.getDataList()
          }
        )
      }
    },
    //获取数据字典列表
    getDictList() {
      this.$get(`dict/getByTypeCodeAsFilter/TEST_STANDARD/Y`).then(
        ({ data: res }) => {
          this.testStandardList = res.data
        }
      )
    },
    //获取区域地址信息
    getAreaTreeList() {
      this.$get(`tree/getTreeByCode/TREE_PROVINCE/Y/false`).then(
        ({ data: res }) => {
          this.areaTreeList = res.data
        }
      )
    },
    //跳转到我的代理商所有水工页面
    cliclHandlerToManagement() {

      this.$router.push({
        path: '/agent/MyAgentEngineer',
        query: { agencyId: this.agentInfo.id ,visible:true},
      })
    },
    // 返回
    goBack() {
      this.$router.back()
    },
    // 点击跳转到 我的下属水工公司界面
    clickHandlerToPlumber() {
      this.$router.push({
        path: '/agent/MyAgentEngineerCompany',
        query: { agentId: this.agentInfo.id ,visible:true},
      })
    },
    // 点击设置按钮跳转到setting
    clickHandlerToSetting() {
      this.$router.push({
        path: '/agent/parametersetting',
        query: {
          agentId: this.agentId,
          visible: this.visible,
          testStandard: this.agentInfo.testStandard,
        },
      })
    },
    // 监听子组件关闭弹框
    closeDialog() {
      this.dialogTableVisible = false
      this.getDataList()
    },
    closePwdDialog() {
      this.dialogPwdVisible = false
    },
    // 打开弹框组件
    openChangePwd(loginAccount) {
      this.dialogPwdVisible = true
      this.$refs.editPwdDialog.setUserId(loginAccount)
    },
    // 打开弹框组件
    openAddEmployee() {
      this.dialogTableVisible = true
      this.dialogTitle = 'Add employee account'
      console.log(this.dialogTableVisible)
    },
    // 打开弹框组件
    openEditEmployee(id) {
      console.log(id)
      this.dialogTableVisible = true
      this.dialogTitle = 'Edit employee account'
      this.$refs.editEmployeeDialog.setUserId(id)
    },
    cancel() {
      this.isDisabled = true
      this.isZb = false
      this.changeInputStyle()
    },
    //修改代理商信息
    updateAgent() {

      var aList = this.areaList
      console.log('area=',this.areaList)
      if(this.areaList==null || this.areaList==''|| this.areaList.length<=0){
        this.$message.error('Area is required')
        return 
      }
      this.$refs.editFormRef.validate(async (valid) => {
        this.agentInfo.agencyArea = this.areaList.join(',')
        console.log(this.agentInfo)

        if (this.saleManId != null) {
          this.agentInfo.salesMan = this.saleManId
        }
        console.log(this.saleManId)
        console.log(this.agentInfo)
        //需要清空，否则提交后台报错
        this.agentInfo.areaList = null
        if (!valid) return
        this.$post('agent/save', this.agentInfo).then(({ data: res }) => {
          if (res.ok) {
            // 刷新列表数据
            this.agentInfo.areaList = aList
            this.saleManId = null
            this.getDataList()
            this.getEntity()
            this.cancel()
            return this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    // js改变查询框的样式,如果dom结构发生改变，下面代码要检查修改
    changeInputStyle() {
      if (this.isDisabled) {
        for (let i = 0; i < this.$refs.left.children.length; i++) {
          this.$refs.left.children[
            i
          ].children[1].children[0].children[0].style.border = 'none'

          this.$refs.left.children[
            i
          ].children[1].children[0].children[0].style.background = '#fff'
        }
      } else {
        for (let i = 0; i < this.$refs.left.children.length; i++) {
          this.$refs.left.children[
            i
          ].children[1].children[0].children[0].style.border =
            '1px solid #D7D7D7'
          // this.$refs.left.children[
          //   i
          // ].children[1].children[0].children[0].style.background = '#F3F7FF'
        }
      }
    },
    edit() {
      this.isDisabled = false
      if (this.visible) {
        this.isZb = true
      } else {
        this.isZb = false
      }

      this.changeInputStyle()
    },

    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },
    //监听字段排序
    sortChange(r) {
      //设置排序字段名
      this.queryInfoparams.sortField = r.prop
      //设置排序字段名
      this.queryInfoparams.sortOrder = r.order

      this.getDataList()
    },
    //监控checkbox的选择,为entity的所有值
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log('multipleSelection', this.multipleSelection)
    },
    // 获取 查询用户数据列表
    getDataList() {
      // 分页查询
      this.queryInfoparams.params.companyId = this.agentId

      this.$post('agent/myEmployeePageQuery', this.queryInfoparams).then(
        ({ data: res }) => {
          this.dataList = res.records
          this.total = res.total
        }
      )
    },

    // 批量启用账号
    async enableBatch() {
      console.log('multipleSelection', this.multipleSelection)
      console.log('multipleSelection', this.multipleSelection.length)
      if (
        this.multipleSelection == null ||
        this.multipleSelection.length <= 0
      ) {
        return this.$message.error('please select record data')
      }

      var ids = []
      this.multipleSelection.forEach((row) => {
        ids.push(row.id)
      })

      console.log(ids)
      // 弹框询问用户是否启用用户
      const confirmResult = await this.$confirm(
        'Enable, keep continue?',
        'Enable Account',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => {
          this.$delete(`agent/startUser`, { idList: ids }).then(
            ({ data: res }) => {
              if (!res.ok) {
                return this.$message.error(res.msg)
              }
              this.$message.success(res.msg)

              this.getDataList()
            }
          )
        })

        .catch((err) => err)
      // 如果用户确认 则 返回值为字符串 confirm
      // 如果用户取消 则 返回值为字符串 cancel
    },

    // 批量禁用账号
    async disableBatch() {
      console.log('multipleSelection', this.multipleSelection)
      console.log('multipleSelection', this.multipleSelection.length)
      if (
        this.multipleSelection == null ||
        this.multipleSelection.length <= 0
      ) {
        return this.$message.error('please select record data')
      }

      var ids = []
      this.multipleSelection.forEach((row) => {
        ids.push(row.id)
      })

      console.log(ids)
      // 弹框询问用户是否启用用户
      const confirmResult = await this.$confirm(
        'Disable, keep continue?',
        'Disable Account',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => {
          this.$delete(`agent/stopUser`, { idList: ids }).then(
            ({ data: res }) => {
              if (!res.ok) {
                return this.$message.error(res.msg)
              }
              this.$message.success(res.msg)

              this.getDataList()
            }
          )
        })
        .catch((err) => err)
      // 如果用户确认 则 返回值为字符串 confirm
      // 如果用户取消 则 返回值为字符串 cancel
    },
  },
  mounted() {
    this.changeInputStyle()
    this.getEntity()
    this.getAreaTreeList()
    this.getDictList()
  },
}
</script>

<style lang='less' scoped>
.el-breadcrumb {
  font-size: 13px;
}
.el-form {
  display: flex;
  .left {
    display: flex;
    width: 90%;
    flex-wrap: wrap;
  }
  .el-form-item {
    margin: 0 10px 20px 0;
    width: 30%;
    /deep/.el-input__inner {
      color: #393838;
    }
    /deep/.el-input__inner::placeholder {
      color: #393838;
    }
  }
  .el-button {
    height: 40px;
  }
  .cancel {
    background: #f2f2f2;
  }
}

i {
  font-size: 22px;
  margin-right: 10px;
}
.saveAndCancel {
  display: flex;
}
.titleText {
  font-size: 14px;
  color: #a4a4a4;
}
.btnsList {
  .el-button {
    margin-left: 10px;
  }
}

.el-pagination {
  display: flex;
  justify-content: flex-end;
}

.btnContainer {
  display: flex;
  justify-content: space-around;
}
</style>